import { ActionTree } from 'vuex'

import { TechpackApi } from '../../services/techpack.service'

import type { TechpackReturnType, TechpackState } from './techpack.types'

import { MutationTypes } from './techpack.mutations'
import { mapTechpackToUITechpackModel } from './mapper'

export const actions: ActionTree<TechpackState, unknown> = {
  async fetchTechpackById({ commit }, { techpackId, productId }: { techpackId: string; productId: string }) {
    commit(MutationTypes.SET_LOADING, true)

    try {
      const { data: techpack } = await TechpackApi.getTechpackById(productId, techpackId)

      if (techpack) {
        const translatedState = mapTechpackToUITechpackModel(techpack as TechpackReturnType)
        commit(MutationTypes.SET_TECHPACK_STATE, translatedState)
      }

      return { data: techpack }
    } catch (err) {
      commit(MutationTypes.SET_ERROR_STATE, err)
    } finally {
      commit(MutationTypes.SET_LOADING, false)
    }
  }
}
